module.exports = __webpack_public_path__ + "img/bluemesa.92ee0c37.png";